const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].hjemmelserklæring.defaults.$get({
      param: {
        tluxCaseId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch hjemmelserklæring defaults");
    }
    return {
      hjemmelserklæring: await res.json()
    };
  },
  head: () => {
    return {
      meta: [{
        title: "Opprett hjemmelserklæring | Alice & Bob"
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});